import { render, staticRenderFns } from "./DocumentEditor.vue?vue&type=template&id=07ac3550&"
import script from "./DocumentEditor.vue?vue&type=script&lang=ts&"
export * from "./DocumentEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports